exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --header-color: #0067AC;\n  --bg-balloon-color: #0066cc;\n  --bg-customer-balloon-color: #0066cc;\n  --text-balloon-color: #000000; }\n\n.iframe {\n  width: 350px;\n  height: 350px;\n  /* Track */\n  /* Handle */\n  /* Handle on hover */ }\n  .iframe ::-webkit-scrollbar {\n    width: 6px; }\n  .iframe ::-webkit-scrollbar-track {\n    border-radius: 10px; }\n  .iframe ::-webkit-scrollbar-thumb {\n    background: #0E75DD;\n    border-radius: 10px; }\n  .iframe ::-webkit-scrollbar-thumb:hover {\n    background: #0E75DD; }\n", ""]);

// exports
